<template>
  <fa-icon :icon="['fab', 'creative-commons']" />
</template>
